// extracted by mini-css-extract-plugin
export default {"config-ctas-desktop":"config-ctas-desktop__irqwQ","icon":"icon__KHr6M","canvas":"canvas__yZaJy"};